import React, { useState } from "react";
import UploadForm from "./UploadForm";
import UploadFileList from "./UploadFileList";
import { useLocation } from "react-router-dom";
import { IBulkRegRequest } from "../../typings/interfaces/Requests/BulkRegRequest";

interface UploadedFile {
  name: string;
  date: string;
  file: File;
}

interface UploadProps {
  registrationType: any;
  bulkRequestedData: IBulkRegRequest;
}

interface inputProps {
  data: {
    regName: string;
    ssalutation: number;
    sapplicantName: string;
    sUEN: string;
    scompanyName: string;
    slicenceNumber: string;
    sorganizationAddress: string;
    sorganizationAddress2: string;
    sorganizationAddress3: string;
    sorganizationAddress4: string;
    sorganizationAddress5: string;
    sorganizationAddress6: string;
    sorganizationAddress7: string;
    sorganizationAddress8: string;
    sorganizationAddress9: string;
    sorganizationAddress10: string;
    smobileNo: string;
    smobilecode: string;
    semail: string;
    sfcRegistrationNo: string;
    scountryOrigin: string;
    sscientificNameString: string;
    scitesAppendixNo: number;
    slegRingNo: string;
    sforeignCITESPermitNo: string;
    sTypeofTag: number;
    sTagNumber: string;
    sVarietyofFish: number;
    sLengthofFish: number;
    sBatchNumber: string;
    sRegisteredQuantityinBatch: number;
    sHarvestDate: Date | null;
    sHatchDate: Date | null;
    sParentMicrochip: string;
    sRemarks: string;
    sMicrochipNumber: string;
    expiryDate: Date | null;
  };
}

const Upload: React.FC<inputProps> = (data) => {
  const location = useLocation();
  const { RegistrationType, bulkRequestData } = location.state;
  // const bannerType = location.state;
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);

  const handleFilesUpload = (files: FileList) => {
    const newFiles: UploadedFile[] = Array.from(files).map((file) => ({
      name: file.name,
      date: new Date().toLocaleDateString(),
      file,
    }));

    setShowUploadForm(true);
    setUploadedFiles([]);
    setUploadedFiles((prevUploadedFiles) => [
      // ...prevUploadedFiles,
      ...newFiles,
    ]);
  };

  return (
    <>
      <UploadForm onFilesUpload={handleFilesUpload} />
      {showUploadForm && (
        <UploadFileList
          uploadedFiles={uploadedFiles}
          registrationType={RegistrationType}
          bulkRequestedData={bulkRequestData}
          inputData={data}
        />
      )}
    </>
  );
};

export default Upload;
